import { Paragraph } from '@audio-network/componentlibrary'
import { Trans, useTranslation } from 'next-i18next'

import Toast, { ToastBody, ToastBold } from '../../Toast'

type ToastProps = {
	tracks?: Track[]
	projectName?: string
	error?: boolean
}

const ToastMessage = ({
	tracks,
	projectName,
	error,
}: ToastProps): JSX.Element => {
	const { t } = useTranslation(['addtoproject'])

	if (error) {
		return <Paragraph>{t('toast-error-message')}</Paragraph>
	}

	let trackInfo

	if (tracks?.length === 1) {
		trackInfo = tracks[0].title
	} else {
		trackInfo = t('tracks-info', { tracksLength: tracks.length })
	}

	return (
		<ToastBody data-testid="toast-success-message">
			<Trans components={{ bold: <ToastBold /> }}>
				{t('toast-success-message', {
					trackInfo: trackInfo,
					project: projectName,
				})}
			</Trans>
		</ToastBody>
	)
}

export default function AddToProjectToast({
	tracks,
	projectName,
	error = false,
}: ToastProps): JSX.Element {
	return (
		<Toast>
			<ToastMessage tracks={tracks} projectName={projectName} error={error} />
		</Toast>
	)
}
